







import Vue from 'vue';
// import * as app from 'firebase/app';

// import { FirestoreDate } from '@/modules/firestore';
// import buyer, { Buyer } from '@/modules/buyer/buyer';
import {
  buyer,
  Buyer,
  firebase,
  calender,
} from 'mostra';

import { SubmitData, AccountInfo } from '@/components/Pages/buyer/GAccountInfo.vue';
// import * as firebase from '@/plugins/firebase';

type DataType = {
  buyer: Buyer | null;
  accountInfo: AccountInfo;
}

// const formatDate = (date: FirestoreDate | null): FirestoreDate | null => {
//   if (!date) return null;
//   if (date instanceof app.firestore.Timestamp) return date.toDate();
//   return date;
// };

export default Vue.extend({
  name: 'buyer-setting-account',
  data(): DataType {
    return {
      buyer: null,
      accountInfo: {},
    };
  },
  async mounted() {
    if (this.$auth && this.$auth.uid) {
      const buyerData = await buyer.load(this.$auth.uid);
      if (buyerData && buyerData.id && buyerData.data) {
        const { data } = buyerData;
        const {
          registeredDate,
          updatedDt,
          email,
          phoneNumber,
        } = data;
        this.buyer = buyerData;
        this.accountInfo = {
          uid: buyerData.id,
          registeredDate: calender.toDate(registeredDate),
          updatedDt: calender.toDate(updatedDt),
          email,
          phoneNumber,
        };
      }
    }
  },
  methods: {
    async onSignOut() {
      try {
        await firebase.auth().signOut();
        window.location.href = '/';
      } catch (error: any) {
        this.$fatal(error);
      }
    },
    async onChangePassword(values: SubmitData) {
      const buyerData = this.buyer;
      if (buyerData && buyerData.id && buyerData.data) {
        this.$loading(true);
        try {
          const { currentPassword, newPassword } = values;
          this.$loading(true);
          const user = firebase.auth().currentUser;
          if (!user || !this.$auth.email) { throw Error('userが取得できませんでした。'); }
          const credential = (firebase.EmailAuthProvider as any).credential(
            this.$auth.email,
            currentPassword,
          );
          await user.reauthenticateAndRetrieveDataWithCredential(credential);
          await user.updatePassword(newPassword);

          this.$success('パスワードを変更しました');
        } catch (error: any) {
          this.$error('パスワードの変更に失敗しました', error);
        } finally {
          this.$loading(false);
        }
      }
    },
  },
});
